// Which market a site locale sells to. Every "is this the US?" and "is this English?" question in
// the frontend goes through here, because they are two different questions since the UK opened:
//
//   locale   URL    market   currency   ships to
//   en       /en    US       USD        US
//   en-GB    /uk    GB       GBP        GB
//   nl, de   /nl…   EU       EUR        NL, BE, DE
//
// English copy, English product names and English content are `isEnglishLocale`. US-only things —
// dollars, inches, states, Christmas cards, referrals, Express Checkout, the running experiments —
// are `marketForLocale(locale) === "US"`.

export type Market = "US" | "GB" | "EU";
export type Currency = "EUR" | "USD" | "GBP";

export function marketForLocale(locale?: string): Market {
  if (locale === "en") return "US";
  if (locale === "en-GB") return "GB";
  return "EU";
}

export function isUsLocale(locale?: string): boolean {
  return locale === "en";
}

export function isEnglishLocale(locale?: string): boolean {
  return locale === "en" || locale === "en-GB";
}

export function currencyForMarket(market: Market): Currency {
  return market === "US" ? "USD" : market === "GB" ? "GBP" : "EUR";
}

export function currencyForLocale(locale?: string): Currency {
  return currencyForMarket(marketForLocale(locale));
}

/** The one country a single-country market ships to; null for the EU market (NL, BE, DE). */
export function countryForMarket(market: Market): "US" | "GB" | null {
  return market === "US" ? "US" : market === "GB" ? "GB" : null;
}

export function currencyForCountry(country?: string): Currency {
  return country === "US" ? "USD" : country === "GB" ? "GBP" : "EUR";
}
